import { Outlet, Link } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { useWebSocket } from '../hooks/useWebSocket'

export function Layout() {
  const { user, logout } = useAuth()
  const { connected } = useWebSocket()
  
  return (
    <div className="min-h-screen bg-gray-100">
      <nav className="bg-white shadow-lg">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex justify-between h-16">
            <div className="flex">
              <div className="flex-shrink-0 flex items-center">
                <h1 className="text-xl font-bold">Stock Research Agent</h1>
              </div>
              <div className="ml-6 flex space-x-8">
                <Link to="/" className="inline-flex items-center px-1 pt-1 text-gray-900 hover:text-blue-600">
                  Dashboard
                </Link>
                <Link to="/analyze" className="inline-flex items-center px-1 pt-1 text-gray-500 hover:text-gray-900">
                  Analyze
                </Link>
                <Link to="/opportunities" className="inline-flex items-center px-1 pt-1 text-gray-500 hover:text-gray-900">
                  Opportunities
                </Link>
                <Link to="/watchlist" className="inline-flex items-center px-1 pt-1 text-gray-500 hover:text-gray-900">
                  Watchlist
                </Link>
                <Link to="/reports" className="inline-flex items-center px-1 pt-1 text-gray-500 hover:text-gray-900">
                  Reports
                </Link>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              {connected ? (
                <span className="flex items-center text-green-600 text-sm">
                  <span className="animate-pulse mr-2">●</span>
                  LIVE
                </span>
              ) : (
                <span className="text-gray-400 text-sm">⚪ Offline</span>
              )}
              <span className="text-gray-600">{user?.signInDetails?.loginId || user?.username || 'User'}</span>
              <button
                onClick={() => logout()}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </nav>
      
      <main className="max-w-7xl mx-auto py-6 px-4">
        <Outlet />
      </main>
      
      <footer className="bg-white mt-8">
        <div className="max-w-7xl mx-auto py-4 px-4 text-center text-gray-500 text-sm">
          Stock Research Agent - Not Financial Advice
        </div>
      </footer>
    </div>
  )
}

